import React from 'react'
import {Link} from "react-router-dom"
import site1 from "../assets/img/site1.png"
import site2 from "../assets/img/site2.png"
import site3 from "../assets/img/site3.png"
import site4 from "../assets/img/site4.png"
import site5 from "../assets/img/site5.png"
import site6 from "../assets/img/site6.png"
import rise from "../assets/img/Rise.png"
import clinica from "../assets/img/clinica.png"

const Protfolio = () => {
  return (
   <>
         <section id="portfolio" className="portfolio section-bg">
            <div className="container">
                <div className="section-title">
                <h2>Portfolio</h2>
                <p>Explore a Selection of My Projects</p>
                <p>Discover a collection of my showcased projects below. Click on the link icon to delve into the details.</p>

                </div>
                <div className="row" data-aos="fade-up">
                    <div className="col-lg-12 d-flex justify-content-center">
                        <ul id="portfolio-flters">
                            <li data-filter="*" className="filter-active">All</li>
                            <li data-filter=".filter-app">App</li>
                            <li data-filter=".filter-card">UI/UX</li>
                            <li data-filter=".filter-web">Web</li>
                        </ul>
                    </div>
                </div>
                <div className="row portfolio-container" data-aos="fade-up" data-aos-delay="100">
                    <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                        <div className="portfolio-wrap"> 
                        <img src={site3}
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href={site3}
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="View"><i
                                        className="bx bx-plus"></i></a>
                                         <a href="https://trevelers-5b602.web.app"
                                     target="_blank"
                                    title="More Details"><i className="bx bx-link"></i></a>
                                    </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-web">
                        <div className="portfolio-wrap"> 
                        <img src={rise} className="img-fluid" alt="rise" />
                            <div className="portfolio-links"> <a
                                    href={rise}
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="Web 3"><i
                                        className="bx bx-plus"></i></a> <a
                                    // href=" https://buisness-success.web.app"
                                    href='https://riseforlearning.com/'
                                    target="_blank"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                        <div className="portfolio-wrap"> <img
                                src={site2}
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href={site2}
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="App 2"><i
                                        className="bx bx-plus"></i></a> <a
                                    href=" https://iphone-779b9.web.app" target="_blank"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-card">
                        <div className="portfolio-wrap"> <img
                                src={site4}
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href={site4}
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="Card 2"><i
                                        className="bx bx-plus"></i></a> <a
                                    href="https://peruca-3859a.web.app" target="_blank"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-web">
                        <div className="portfolio-wrap"> <img
                                src={site5}
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href={site5}
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="Web 2"><i
                                        className="bx bx-plus"></i></a> <a
                                    href="https://designers-caf12.web.app/" target="_blank"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                        <div className="portfolio-wrap"> <img
                                src={clinica}
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href={clinica}
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="App 3"><i
                                        className="bx bx-plus"></i></a> <a
                                    // href="https://interior-designers.web.app/"
                                    href='https://drclinica.com/'
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6 portfolio-item filter-card">
                        <div className="portfolio-wrap"> <img
                                src="https://bootstrapmade.com/demo/templates/iPortfolio/assets/img/portfolio/portfolio-7.jpg"
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href="https://bootstrapmade.com/demo/templates/iPortfolio/assets/img/portfolio/portfolio-7.jpg"
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="Card 1"><i
                                        className="bx bx-plus"></i></a> <a
                                    href="https://bootstrapmade.com/demo/templates/iPortfolio/portfolio-details.html"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-card">
                        <div className="portfolio-wrap"> <img
                                src="https://bootstrapmade.com/demo/templates/iPortfolio/assets/img/portfolio/portfolio-8.jpg"
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href="https://bootstrapmade.com/demo/templates/iPortfolio/assets/img/portfolio/portfolio-8.jpg"
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="Card 3"><i
                                        className="bx bx-plus"></i></a> <a
                                    href="https://bootstrapmade.com/demo/templates/iPortfolio/portfolio-details.html"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 portfolio-item filter-web">
                        <div className="portfolio-wrap"> <img
                                src="https://bootstrapmade.com/demo/templates/iPortfolio/assets/img/portfolio/portfolio-9.jpg"
                                className="img-fluid" alt=""/>
                            <div className="portfolio-links"> <a
                                    href="https://bootstrapmade.com/demo/templates/iPortfolio/assets/img/portfolio/portfolio-9.jpg"
                                    data-gallery="portfolioGallery" className="portfolio-lightbox" title="Web 3"><i
                                        className="bx bx-plus"></i></a> <a
                                    href="https://bootstrapmade.com/demo/templates/iPortfolio/portfolio-details.html"
                                    title="More Details"><i className="bx bx-link"></i></a></div>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
   </>
  )
}

export default Protfolio